import { render } from "./CookieBar.vue?vue&type=template&id=990fabce&scoped=true"
import script from "./CookieBar.vue?vue&type=script&lang=js"
export * from "./CookieBar.vue?vue&type=script&lang=js"

import "./CookieBar.vue?vue&type=style&index=0&id=990fabce&lang=css"
import "./CookieBar.vue?vue&type=style&index=1&id=990fabce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-990fabce"]])

export default __exports__